import { render } from "./BulkQuestionCreator.vue?vue&type=template&id=4a901516&scoped=true"
import script from "./BulkQuestionCreator.vue?vue&type=script&lang=js"
export * from "./BulkQuestionCreator.vue?vue&type=script&lang=js"

import "./BulkQuestionCreator.vue?vue&type=style&index=0&id=4a901516&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a901516"]])

export default __exports__